var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "defaultMsgModal", "data-backdrop": "static" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content default-modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("div", { staticClass: "card text-center" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("img", {
                  staticClass: "expiry_logo card-img-top",
                  attrs: {
                    src: require("../../../public/static/images/icons/expiry.svg"),
                    alt: "expiry-icon",
                  },
                }),
                _c("div", { staticClass: "default-message pb-0" }, [
                  _vm.defaultMessage && _vm.defaultMessage.message
                    ? _c("p", {}, [_vm._v(_vm._s(_vm.defaultMessage.message))])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "default-message" }, [
                  _vm.defaultMessage &&
                  _vm.defaultMessage.show_link &&
                  _vm.isDashboardCustomizable
                    ? _c("span", {}, [
                        _vm._v(" Please "),
                        _c(
                          "a",
                          {
                            staticClass: "cursor-pointer",
                            on: {
                              click: function ($event) {
                                return _vm.redirect()
                              },
                            },
                          },
                          [_vm._v("click here")]
                        ),
                        _vm._v(
                          " to customize your dashboard under Account Settings -> Preferences "
                        ),
                      ])
                    : _vm._e(),
                  _vm.defaultMessage &&
                  _vm.defaultMessage.show_link &&
                  !_vm.isDashboardCustomizable
                    ? _c("span", {}, [
                        _vm._v(
                          " You currently do not have an option to customize your dashboard as you are not subscribed to any Premium services "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12 ok-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-blue-button",
                      on: { click: _vm.submitModal },
                    },
                    [_vm._v("OK")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }